var m = require('mithril');

var groupsFilterComponent = {};

groupsFilterComponent.view = function (vnode) {
  return m('span.ba.b--blue.br2.ph1.flex.items-center.h2', {
    onclick: () => {
      vnode.attrs.filterGroupsModal.editDialogue(vnode.attrs.groups, vnode.attrs.selectedGroups, vnode.attrs.getAssetsByGroup)
    }
  },[
    m('label.mr2.f5.blue', 'Groups:'),
    m('span.mr2.mv1.f4', `${vnode.attrs.selectedGroups().length > 0 ? vnode.attrs.selectedGroups().length : 'All'}`),
  ])
}

module.exports = groupsFilterComponent;